import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app.jsx';
import { AuthProvider } from './comum/Context/auth';
import packageJson from '../package.json'; // Importa o arquivo de configuração

const container = document.getElementById('root');
const root = createRoot(container);

// Função para forçar Refresh (Ctrl + F5 funcional)
const checkAppVersion = () => {
    const currentVersion = packageJson.version;
    const savedVersion = localStorage.getItem('app_version');

    if (savedVersion !== currentVersion) {
        localStorage.setItem('app_version', currentVersion);
        
        // Adiciona um timestamp na URL para "quebrar" o cache do servidor/browser
        const url = new URL(window.location.href);
        url.searchParams.set('v', currentVersion);
        
        // substitui a URL e recarrega limpando cache
        window.location.replace(url.toString());
        
        // Timeout pequeno para garantir a limpeza em alguns browsers
        setTimeout(() => {
            window.location.reload(true);
        }, 50);
        
        return true; // Indica que está recarregando
    }
    return false;
};

// Só renderiza se não houver necessidade de refresh
if (!checkAppVersion()) {
    root.render(
      <AuthProvider>
        <App />
      </AuthProvider>
    );
}


{/*import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app.jsx';
import { AuthProvider } from './comum/Context/auth';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);*/}